export { StarOutlineIcon } from "./star-outline";
